import FJAIVideoGeneratorRight from '../view/FJAIVideoGeneratorRight.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJRequirementsUtil from '../../../../util/FJRequirementsUtil.js';
import FJActionAIVideoGenerator from '../../../../redux/action/FJActionAIVideoGenerator.js';
import { setSliceIsDraggingFileAction, setSliceSelectListAction } from '../../../../redux/slices/FJSliceCommon.js';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';

const FJAIVideoGeneratorRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const currentGenerateStatus = useSelector(state => state.AIVideoGenerator.currentGenerateStatus);
    const generatingVideoNum = useSelector(state => state.AIVideoGenerator.generatingVideoNum);
    const isShowGeneratingVideoNum = useSelector(state => state.AIVideoGenerator.isShowGeneratingVideoNum);
    const historyList = useSelector(state => state.common.historyList);
    const sortType = useSelector(state => state.AIVideoGenerator.sortType);
    const tabIndex = useSelector(state => state.AIVideoGenerator.tabIndex);
    const currentTackId = useSelector(state => state.AIVideoGenerator.currentTackId);
    const showHistoryNum = FJRequirementsUtil.getSortHistoryList(historyList, sortType).length;
    const currentInfo = historyList.find(item => item.eventId === currentTackId) || {};
    const creditNumber = useSelector(state => state.common.creditNumber);
    const getCredit = () => {
        dispatch(FJActionCommon.getCreditsAction());
    };

    const setSortType = type => {
        if (type !== sortType) {
            dispatch(setSliceSelectListAction([]));
        }
        dispatch(FJActionAIVideoGenerator.setSortTypeAction(type));
    };

    const uploadFile = useCallback(
        file => {
            dispatch(FJActionAIVideoGenerator.uploadFileAction(file));
        },
        [dispatch],
    );

    const setIsDraggingFile = useCallback(
        value => {
            if (tabIndex === 1) {
                dispatch(setSliceIsDraggingFileAction(value));
            }
        },
        [dispatch, tabIndex],
    );

    const reGenerate = useCallback(() => {
        dispatch(FJActionAIVideoGenerator.retryTaskAction(currentInfo.id));
    }, [dispatch, currentInfo]);

    const jumpHistory = () => {
        dispatch(FJActionCommon.setHeaderTabIndexAction(1));
    };

    return (
        <FJAIVideoGeneratorRight
            currentGenerateStatus={currentGenerateStatus}
            getCredit={getCredit}
            imgUrl={currentInfo.originalUrl}
            headerTabIndex={headerTabIndex}
            generatingVideoNum={generatingVideoNum}
            isShowGeneratingVideoNum={isShowGeneratingVideoNum}
            sortType={sortType}
            setSortType={setSortType}
            showHistoryNum={showHistoryNum}
            uploadFile={uploadFile}
            setIsDraggingFile={setIsDraggingFile}
            reGenerate={reGenerate}
            jumpHistory={jumpHistory}
            creditNumber={creditNumber}
        />
    );
};
export default FJAIVideoGeneratorRightContainer;
